import {NgModule} from '@angular/core';
import {Routes, RouterModule} from '@angular/router';
import {PoActivityOverviewComponent} from './po-activity-overview.component';

const routes: Routes = [{path: '', component: PoActivityOverviewComponent}];

@NgModule({
	imports: [RouterModule.forChild(routes)],
	exports: [RouterModule]
})
export class PoActivityOverviewRoutingModule {
}
